import { render, staticRenderFns } from "./DoubleInput.vue?vue&type=template&id=fb1e1404&scoped=true"
import script from "./DoubleInput.vue?vue&type=script&lang=js"
export * from "./DoubleInput.vue?vue&type=script&lang=js"
import style0 from "./DoubleInput.vue?vue&type=style&index=0&id=fb1e1404&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb1e1404",
  null
  
)

export default component.exports